/*
 *
 * CollaboratorsEdit reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_COLLABORATOR_INFO_WATCHER,
  GET_COLLABORATOR_INFO_SUCCESS,
  UPDATE_COLLABORATOR_WATCHER,
  UPDATE_COLLABORATOR_SUCCESS,
  GET_MEASURES_WATCHER,
  GET_MEASURES_SUCCESS,
  GET_MEASURES_FAILED,
  GET_LANGUAGE_WATCHER,
  GET_LANGUAGE_SUCCESS,
  GET_LANGUAGE_FAILED,
} from "./constants"

export const initialState = fromJS({
  divisions: [],
  collaborator: {},
  currencies: [],
  categories: [],
  leaders: [],
  genders: [],
  locations: [],
  isLoadingCollaborator: false,
  isUpdating: false,
  isLoadingMeasures: false,
  measuresAffected: [],
  languages: [],
  isLoadingLanguage: true,
})

function collaboratorsEditReducer(state = initialState, action) {
  switch (action.type) {
    case GET_LANGUAGE_WATCHER:
      return state.set("isLoadingLanguage", true)
    case GET_LANGUAGE_SUCCESS:
      return state
        .set("languages", action.payload)
        .set("isLoadingLanguage", false)
    case GET_LANGUAGE_FAILED:
      return state.set("isLoadingLanguage", false).set("languages", [])
    case GET_COLLABORATOR_INFO_WATCHER:
      return state.set("isLoadingCollaborator", true)
    case GET_COLLABORATOR_INFO_SUCCESS:
      return state
        .set("isLoadingCollaborator", false)
        .set("divisions", action.payload.divisions)
        .set("categories", action.payload.categories)
        .set("currencies", action.payload.currency)
        .set("collaborator", action.payload.collaborator)
        .set("leaders", action.payload.leaders)
        .set("genders", action.payload.genders)
        .set("locations", action.payload.locations)
    case UPDATE_COLLABORATOR_WATCHER:
      return state.set("isUpdating", true)
    case UPDATE_COLLABORATOR_SUCCESS:
      return state.set("isUpdating", false)
    case GET_MEASURES_WATCHER:
      return state.set("measuresAffected", []).set("isLoadingMeasures", true)
    case GET_MEASURES_SUCCESS:
      return state
        .set("measuresAffected", action.payload.result.measures)
        .set("isLoadingMeasures", false)
    case GET_MEASURES_FAILED:
      return state
    default:
      return state
  }
}

export default collaboratorsEditReducer
